import { render, staticRenderFns } from "./b-menu-pagination.vue?vue&type=template&id=359b0c50&scoped=true&"
import script from "./b-menu-pagination.vue?vue&type=script&lang=js&"
export * from "./b-menu-pagination.vue?vue&type=script&lang=js&"
import style0 from "./b-menu-pagination.vue?vue&type=style&index=0&id=359b0c50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359b0c50",
  null
  
)

export default component.exports